import React from "react";
import { Helmet } from "react-helmet";
import { Switch, Route, useRouteMatch } from "react-router-dom";
import PatientsDashboard from "./PatientsDashboard";
import PatientAdd from "./AddPatient";

function Patients() {
  const match = useRouteMatch();
  return (
    <>
      <Helmet>
        <title>Patient</title>
      </Helmet>
      <Switch>
        <Route path={`${match.url}/add`} component={PatientAdd} />
        <Route path={`${match.url}`} component={PatientsDashboard} />
      </Switch>
    </>
  );
}
export default Patients;
